import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { Dispatch } from "redux"
import { fetchAllTaxes } from "~Shared/store/actions/tax/taxActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToTax = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.DELETE) {
            dispatch(fetchAllTaxes())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Tax Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
